import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { AppError, JurisdictionSelector, MessageService, SessionSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { merge, of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { HOME_CONTENT_WIDGET_ACTION_TYPE, HomeContentWidgetAction } from "./home-content-widget.action";
import { HOME_CONTENT_WIDGET_CONTEXT } from "./home-content-widget.const";
import { HomeContentWidgetService } from "./home-content-widget.service";

@Injectable()
/**
 * @deprecated - [fabric-deprecated] - Use HomeContentWidgetService from svc-content instead
 */
export class HomeContentWidgetEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(ContentServiceCommand.GetHomeContentWidget) instead
	 */
	getWidgets$ = createEffect(() =>
		this.actions$.pipe(
			ofType(HOME_CONTENT_WIDGET_ACTION_TYPE.get),
			withLatestFrom(
				this.store.pipe(select(this.sessionSelector.isAuthenticated())),
				this.store.pipe(select(JurisdictionSelector.get), ignoreNil())
			),
			switchMap(([, isAuthenticated, jurisdiction]) =>
				this.service
					.get({
						isLoggedIn: isAuthenticated,
						jurisdiction,
					})
					.pipe(
						map((response) => this.action.getSuccess(response)),
						catchError((error: AppError) => of(this.action.getFail(error)))
					)
			)
		)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetHomeContentWidget) instead
	 */
	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[HOME_CONTENT_WIDGET_ACTION_TYPE.getFail]: HOME_CONTENT_WIDGET_CONTEXT.get,
			}),
			this.messageService.mapClearByContext$({
				[HOME_CONTENT_WIDGET_ACTION_TYPE.get]: HOME_CONTENT_WIDGET_CONTEXT.get,
			})
		)
	);

	constructor(
		private action: HomeContentWidgetAction,
		private actions$: Actions,
		private service: HomeContentWidgetService,
		private store: Store<CommonState>,
		private messageService: MessageService,
		private sessionSelector: SessionSelector
	) {}
}
